<template>
  <div>
    <b-container class="wide">
      <b-row class="no-margin-left ml-3 mt-5">
        <b-button
            class="mb-4"
            variant="outline-primary"
            @click="isCustomerBooking ? $router.push({ name: 'sales' }) : $router.push({ name: 'user-login', params: $route.params.marketId })"
        >
          <b-icon icon="arrow-left" class="mr-2" />
          {{ $t('links.admin.go_back') }}
        </b-button>
      </b-row>
      <b-row class="no-margin-left">
        <b-card-group deck>
          <b-col cols="auto" v-for="(shelfType, key) in shelfTypes" :key="key">
            <b-card
              header-class="text-center font-weight-bold"
              body-class="text-center"
              class="mb-5 mr-2 booking-image-card"
            >
              <template #header>
                <h5>{{ shelfType.name }}</h5>
              </template>
              <div class="booking-image-wrapper">
                <b-card-img
                  top
                  v-if="shelfType.image"
                  :src="shelfType.image"
                  :alt="shelfType.name"
                  class="booking-image"
                />
                <div v-else class="shelf-type-placeholder">
                  <b-card-img
                    top
                    :src="require('@base/assets/images/svg/shelf-placeholder.svg')"
                    class="booking-image"
                  />
                </div>
              </div>

              <b-card-text class="small mt-2 px-2">
                {{ shelfType.description }}
              </b-card-text>

              <template #footer>
                <div class="d-flex justify-content-center">
                  <b-button
                    size="sm"
                    class="mr-2"
                    v-b-tooltip.hover
                    variant="success"
                    @click="selectShelfType(shelfType)"
                  >
                    {{ $t('table.shelf_types.button_select') }}
                  </b-button>
                </div>
              </template>
            </b-card>
          </b-col>
        </b-card-group>
      </b-row>
    </b-container>
  </div>
</template>

<script>

  export default {
    name: 'SelectShelfTypeComponent',

    data () {
      return {
        loading: false,
      }
    },

    props: {
      shelfTypes: {
        type: Array,
        required: true,
      },
      isCustomerBooking: {
        type: Boolean,
        default: false,
      }
    },

    methods: {
      selectShelfType (shelfTypeObj) {
        this.$emit('shelfTypeSelected', shelfTypeObj)
      },
    }
  }
</script>

<style scoped>
  .card .card-header {
    background-color: transparent;
    border-color: transparent;
    padding: 0.6rem 0 0 0;
  }

  .card .card-body {
    padding: 0;
  }

  .booking-image-card {
    width: 250px;
    min-height: 420px !important;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    transition: transform 0.2s ease;
  }

  .booking-image-card:hover {
    transform: translateY(-4px);
  }

  .booking-image:hover {
    transform: scale(1.08);
  }

  .booking-image-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .booking-image {
    width: 100%;
    height: auto;
    object-fit: contain;
    object-position: center;
    transition: transform 0.3s ease;
  }

  .shelf-type-placeholder {
    width: 200px;
    min-height: 210px !important;
    border: 2px dashed #c4c4c4;
    border-radius: 6px;
  }

</style>